import axios from "axios";
import { API_URL } from "../config/constants";


const END_POINT = `${API_URL}admin-settings/`;

export const addSetting = (label:string,value:string,key:string) => {
   
    return axios
        .post(`${END_POINT}add-setting`, {label,value,key})
        .then((response) => {
            return response;
        }).catch(e => {
            console.log("add s", e)
            return e?.response;
        });
};

export const getSetting = () => {
    return axios
        .get(`${END_POINT}get-setting`)
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const updateSetting = ( data: any) => {
    return axios
        .put(`${END_POINT}update-setting`,
            {data},
            // {
            //     headers: {
            //         'Content-Type': 'multipart/form-data'
            //     }
            // }
        )
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const deleteSettings = (id: string | null) => {
    return axios
        .delete(`${END_POINT}delete-setting/${id}`)
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};


export const addAddress = (formData:any) => {
   console.log('formData',formData)
    return axios
        .put(`${END_POINT}add-address`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then((response) => {
            return response;
        }).catch(e => {
            console.log("address added successfully", e)
            return e?.response;
        });
};